import React from 'react';
import ReactDOM from 'react-dom/client';

const rootCache = new Map(); // Cache for React roots

/**
 * Mount a React component into a container element.
 * @param {React.ComponentType} ReactComponent - The React component to render.
 * @param {Object} props - Props to pass to the React component.
 * @param {string} containerId - The ID of the container element.
 */
export function mountReactComponent(ReactComponent, props, containerId) {
    const container = document.getElementById(containerId);
    if (container) {
        let root = rootCache.get(containerId);

        if (!root) {
            root = ReactDOM.createRoot(container); // Create root if it doesn't exist
            rootCache.set(containerId, root); // Cache the root
        }

        root.render(<ReactComponent {...props} />); // Render the component
    } else {
        console.error(`Container with id "${containerId}" not found.`);
    }
}

/**
 * Unmount a React component from a container element.
 * @param {string} containerId - The ID of the container element.
 */
export function unmountReactComponent(containerId) {
    const container = document.getElementById(containerId);
    const root = rootCache.get(containerId);

    if (container && root) {
        root.unmount(); // Unmount the React component
        rootCache.delete(containerId); // Remove the root from the cache
    } else {
        console.warn(`No React root found for container with id "${containerId}".`);
    }
}
